<div class="wrapper" [attr.data-test]="testId()">
    <i class="pi pi-search"></i>
    <input [formControl]="searchControl" [placeholder]="placeholder()" [attr.data-test]="testId() + '-input'" (keydown.enter)="onSearch()" />
    @if (searchControl.value) {
        <button class="clear" [attr.data-test]="testId() + '-clear'" (click)="onClear()">
            <i class="pi pi-times"></i>
        </button>
    }
</div>
